// 文件剪贴板的数据模型。
// 路径只在本机主进程中使用，永远不会通过 WebRTC 发给对端；网络上只传文件名、大小和内容。

export interface ClipboardFileInfo {
  name: string;
  size: number;
  /** 普通文件省略此字段；图片剪贴板使用 image。 */
  kind?: ClipboardFileKind;
  /** 图片剪贴板的 MIME 类型，例如 image/png。 */
  mimeType?: string;
}

export interface ClipboardFileData extends ClipboardFileInfo {
  data: ArrayBuffer;
}

export type ClipboardFileKind = 'file' | 'image';

export const MAX_CLIPBOARD_FILE_COUNT = 32;
export const MAX_CLIPBOARD_FILE_BYTES = 1024 * 1024 * 1024;
// 图片走独立文件通道，但仍需限制单次读取，避免把剪贴板中的超大位图
// 一次性复制到内存后拖慢视频和输入。普通文件仍沿用 1GB 批次上限。
export const MAX_CLIPBOARD_IMAGE_BYTES = 32 * 1024 * 1024;

export function normalizeClipboardImageMimeType(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const mimeType = value.trim().toLowerCase();
  if (mimeType === 'image/jpg') return 'image/jpeg';
  return /^image\/(?:png|jpeg|webp|gif|bmp)$/.test(mimeType) ? mimeType : null;
}

export function isClipboardImage(file: Pick<ClipboardFileInfo, 'kind' | 'mimeType'>): boolean {
  return file.kind === 'image' && normalizeClipboardImageMimeType(file.mimeType) !== null;
}

export function clipboardFilesSignature(files: ClipboardFileInfo[]): string {
  return files
    .map((file) => `${file.name}\u0000${file.size}\u0000${file.kind || 'file'}\u0000${file.mimeType || ''}`)
    .join('\u0001');
}
